module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl3-100.875a68c9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-C-lvl3-100.png
// module id = 3392
// module chunks = 11